import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';
import { useLang } from '../i18n';
import { getLegalDocs } from '../legalContent';

export const LegalDialog = ({ docKey, onClose }) => {
  const { t, lang } = useLang();
  const open = !!docKey;
  const docs = getLegalDocs(lang);
  const doc = docKey ? docs[docKey] : null;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">{doc?.title}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[70vh] pr-4">
          <div className="space-y-5 pb-2">
            {doc?.sections.map((s) => (
              <section key={s.h} className="space-y-1.5">
                <h3 className="font-heading text-sm font-semibold text-foreground">{s.h}</h3>
                {s.p.map((para, j) => (
                  <p key={`${s.h}-${j}`} className="text-sm leading-relaxed text-muted-foreground">{para}</p>
                ))}
              </section>
            ))}
            <p className="pt-2 text-xs text-muted-foreground">{docs.updated}</p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
